<template>
    <div class="w-full">
        <SpecialGrid
            v-if="filteredEventsByDate.length"
            :events="filteredEventsByDate"
            :expandedEventId="expandedEventId"
            :isResults="true"
            @eventClick="onEventRowClick"
            class="w-full"
        />
        <div
            v-else-if="isLoading"
            class="spinner-container--terminal"
        >
            <SpinnerBars/>
        </div>
        <div
            v-else
            class="empty-state__specials--terminal"
        >
            <Illustration large image="/static/img/illustrations/terminal/offer__empty-state--dark.svg"/>
            <div class="empty-state__specials-copy">
                {{ $t('no results found for') | capitalize }}: <i>{{ selectedDate | formatDateTime('ddmmyyyy')}}</i>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import DateUtils from '@core/utils/date/DateUtils';
    import SpecialGrid from 'src/terminal/app/modules/shared/special/SpecialGrid.vue';
    import { errorGuard } from 'src/app/utils';

    export default {
        name: 'SpecialsResultContainer',
        data() {
            return {
                isLoading: false,
            };
        },
        async created() {
            await this.loadData();
            if (this.expandedEventId) {
                this.fetchSpecialEventResultById(this.expandedEventId);
            }
        },
        watch: {
            selectedDate(a, b) {
                if (!DateUtils.isEqual(a, b)) {
                    this.loadData();
                }
            },
        },
        computed: {
            ...mapGetters('ui/results/specials', [
                'filteredEventsByDate',
            ]),
            ...mapGetters('ui/results', [
                'expandedEventId',
            ]),
            ...mapGetters('ui/results', [
                'timeWindow',
                'selectedDate',
            ]),
        },
        methods: {
            ...mapActions('data/results/specials', [
                'fetchSpecialEventResults',
                'fetchSpecialEventResultById',
            ]),
            ...mapActions('ui/results/specials', [
                'toggleExpandedEventId',
            ]),
            onEventRowClick(eventId) {
                if (eventId !== this.expandedEventId) {
                    this.fetchSpecialEventResultById(eventId);
                }
                this.toggleExpandedEventId(eventId);
            },
            async loadData() {
                this.isLoading = true;
                await errorGuard({
                    action: async () => {
                        const [startDate, endDate] = this.timeWindow;
                        await this.fetchSpecialEventResults({ startDate, endDate });
                    },
                });
                this.isLoading = false;
            },
        },
        components: {
            SpecialGrid,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/results/specialOffer/SpecialsResultContainer.vue